<template>
    <div class="phi-block-obligations-report-pdf">
        <section v-if="action != 'delete'">
            <div v-if="!post">
                <div class="content-file" v-if="urlPdf">
                    <a class="file" :href="urlPdf" target="_blank">
                        <mu-icon value="insert_drive_file" :size="64" class="preview-img-item" />
                        <div class="preview">{{ $t('Statement of Account') }}</div>
                    </a>
                </div>
            </div>
            <div v-else>
                <div class="content-file">
                    <a class="file" target="_blank">
                        <mu-icon value="insert_drive_file" :size="64" class="preview-img-item" />
                        <div class="preview">{{ $t('Statement of Account') }}</div>
                    </a>
                </div>
            </div>
        </section>

        <section class="delete" v-if="action == 'delete'">
            <h1>{{ $t('Remove statement block?') }}</h1>
            <button type="button" class="phi-button danger" @click="$emit('destroy')">{{ $t('action.delete') }}</button>
            <button type="button" class="phi-button cancel" @click="$emit('reset')">{{ $t('action.cancel') }}</button>
        </section>
    </div>
</template>

<script>
import useApi from '@/modules/api/mixins/useApi';
import apiStore from '@/modules/store/api/index.js';
import md5 from 'blueimp-md5';

export default {
    phiBlock: {
        title: "obligationsReportPdf",
        icon: "payments",
        actions: {
            delete: {
                title: "delete"
            }
        }
    },
    name: "phi-block-obligations-report-pdf",
    mixins: [useApi],
    $api: apiStore,
    props: ["block", "action", "post"],
    data() {
		return {
            urlPdf: ""
		}
	},
    created() {
        if (!this.block.url) {
            this.initBlock();
        } else {
            this.reload();
        }
    },
    methods: {
        async reload() {
            var urlCompleta = window.location.href;
            var url = new URL(urlCompleta);
            var valorPerson = url.searchParams.get("person") ? url.searchParams.get("person") : this.$store.state.user.id;

            var urlObj = new URL(this.block.url);
            urlObj.searchParams.set("person", valorPerson);

            var date = urlObj.searchParams.get("date");

            var newURLBlock = urlObj.toString();

            this.$api.getConfigV3("LOCKED_ARGUMENT_SALT").then(
				response => {
					let _ach = md5(`${valorPerson}${date}${response}`);
					newURLBlock = `${newURLBlock}&_ach=${_ach}`;

                    this.urlPdf = newURLBlock;
				}
            );
        },
        async initBlock() {
            let person_id = this.$store.state.user.id;
            let baseUrl = this.$store.state.url.replace(".api", "");
            let fechaActual = new Date();
            let timestampFechaActual = Math.floor(fechaActual.getTime() / 1000);

            const response = await fetch(`${baseUrl}/rest/1/config?name=PASSWORD_PDF`);
            const data = await response.json();
            const passwordPdf = data;

            let notice = "";
            switch (passwordPdf) {
            case "document":
                notice = this.$t("The password for the pdf is your document number registered in Phidias.");
                break;
            case "birthday":
                notice = this.$t("The password for the pdf is your date of birth registered in Phidias in DDMMAA format (e.g. 020225).");
                break;
            case "phone":
                notice = this.$t("The password for the pdf is your phone number registered in Phidias.");
                break;
            case "mobile":
                notice = this.$t("The password to open the PDF is your cell phone number registered in the system, including your country code. Be sure to include the international prefix with the plus sign (+).");
                break;
            default:
                notice = this.$t("The password for the pdf is your id registered in Phidias.");
                break;
            }

            this.block.url = `${baseUrl}/debit/sapdf?person=${person_id}&date=${timestampFechaActual}`;

            this.block.description = `<br><div style="margin-top: 10px;"><a href="${this.block.url}" target="_blank" style="text-decoration: none; display: inline-block; background-color: #fff; width: 250px; border-radius: 8px; border: 1px solid #237BBA; color: #237BBA !important; text-align: center; padding: 10px; font-weight: bold; font-size: 12px">${this.$t("Download statement of account")}</a></div><p><span style="font-size: 12px; color: red;">${this.$t("Reminder")}: ${notice}</span></p>`;

            this.$emit("change");
        },

    },
    i18n: {
        "en": {
            "Reminder": "Reminder",
            "The password for the pdf is your document number registered in Phidias.": "The password for the pdf is your document number registered in Phidias.",
            "The password for the pdf is your date of birth registered in Phidias in DDMMAA format (e.g. 020225).": "The password for the pdf is your date of birth registered in Phidias in DDMMAA format (e.g. 020225).",
            "The password for the pdf is your phone number registered in Phidias.": "The password for the pdf is your phone number registered in Phidias.",
            "The password to open the PDF is your cell phone number registered in the system, including your country code. Be sure to include the international prefix with the plus sign (+).": "The password to open the PDF is your cell phone number registered in the system, including your country code. Be sure to include the international prefix with the plus sign (+). Example: +57315332211.",
            "The password for the pdf is your id registered in Phidias.": "The password for the pdf is your id registered in Phidias.",
            "Download statement of account": "Download statement of account",
            "Statement of Account": "Statement of Account",
            "Remove statement block?": "Remove statement block?",
        },

        "es": {
            "Reminder": "Recordatorio",
            "The password for the pdf is your document number registered in Phidias.": "La contraseña para el pdf es su número de documento registrado en Phidias.",
            "The password for the pdf is your date of birth registered in Phidias in DDMMAA format (e.g. 020225).": "La contraseña para el pdf es su fecha de nacimiento registrada en Phidias en formato DDMMAA (por ejemplo 020225).",
            "The password for the pdf is your phone number registered in Phidias.": "La contraseña para el pdf es su número de teléfono registrado en Phidias.",
            "The password to open the PDF is your cell phone number registered in the system, including your country code. Be sure to include the international prefix with the plus sign (+).": "La contraseña para abrir el PDF es tu número de celular registrado en el sistema, incluyendo el indicativo de tu país. Asegúrate de incluir el prefijo internacional con el signo más (+). Ejemplo: +57315332211.",
            "The password for the pdf is your id registered in Phidias.": "La contraseña para el pdf es su id registrado en Phidias.",
            "Download statement of account": "Descargar estado de cuenta",
            "Statement of Account": "Estado de cuenta",
            "Remove statement block?": "Eliminar bloque de estado de cuenta?",
        },

        "it": {
            "Reminder": "Promemoria",
            "The password for the pdf is your document number registered in Phidias.": "La password per il pdf è il numero del documento registrato in Fidia.",
            "The password for the pdf is your date of birth registered in Phidias in DDMMAA format (e.g. 020225).": "La password per il pdf è la data di nascita registrata in Fidia nel formato DDMMAA (es. 020225).",
            "The password for the pdf is your phone number registered in Phidias.": "La password per il pdf è il numero di telefono registrato in Fidia.",
            "The password to open the PDF is your cell phone number registered in the system, including your country code. Be sure to include the international prefix with the plus sign (+).": "La password per aprire il PDF è il numero di cellulare registrato nel sistema, compreso il prefisso internazionale. Assicurarsi di includere il prefisso internazionale con un segno più (+). Esempio: +57315332211.",
            "The password for the pdf is your id registered in Phidias.": "La password per il pdf è il id registrato in Fidia.",
            "Download statement of account": "Scarica l'estratto conto",
            "Statement of Account": "Estratto conto",
            "Remove statement block?": "Rimuovere il blocco delle dichiarazioni?",
        },

        "fr": {
            "Reminder": "Rappel :",
            "The password for the pdf is your document number registered in Phidias.": "Le mot de passe du pdf est votre numéro de document enregistré dans Phidias.",
            "The password for the pdf is your date of birth registered in Phidias in DDMMAA format (e.g. 020225).": "Le mot de passe du pdf est votre date de naissance enregistrée dans Phidias au format DDMMAA (par exemple 020225).",
            "The password for the pdf is your phone number registered in Phidias.": "Le mot de passe du pdf est votre numéro de téléphone enregistré dans Phidias.",
            "The password to open the PDF is your cell phone number registered in the system, including your country code. Be sure to include the international prefix with the plus sign (+).": "Le mot de passe pour ouvrir le PDF est votre numéro de téléphone portable enregistré dans le système, y compris l'indicatif de votre pays. Veillez à inclure le préfixe international avec le signe plus (+). Exemple : +57315332211.",
            "The password for the pdf is your id registered in Phidias.": "Le mot de passe du pdf est votre id enregistré dans Phidias.",
            "Download statement of account": "Télécharger le relevé de compte",
            "Statement of Account": "Relevé de compte",
            "Remove statement block?": "Supprimer le bloc de déclaration ?",
        },

        "de": {
            "Reminder": "Zur Erinnerung",
            "The password for the pdf is your document number registered in Phidias.": "Das Passwort für die PDF-Datei ist Ihre in Phidias registrierte Dokumentennummer.",
            "The password for the pdf is your date of birth registered in Phidias in DDMMAA format (e.g. 020225).": "Das Kennwort für die PDF-Datei ist Ihr in Phidias registriertes Geburtsdatum im Format DDMMAA (z. B. 020225).",
            "The password for the pdf is your phone number registered in Phidias.": "Das Passwort für die PDF-Datei ist Ihre in Phidias registrierte Telefonnummer.",
            "The password to open the PDF is your cell phone number registered in the system, including your country code. Be sure to include the international prefix with the plus sign (+).": "Das Passwort zum Öffnen der PDF-Datei ist Ihre im System registrierte Mobiltelefonnummer, einschließlich Ihrer Landesvorwahl. Achten Sie darauf, die internationale Vorwahl mit einem Pluszeichen (+) zu versehen. Beispiel: +57315332211.",
            "The password for the pdf is your id registered in Phidias.": "Das Passwort für die PDF-Datei ist Ihre bei Phidias registrierte ID.",
            "Download statement of account": "Download Kontoauszug",
            "Statement of Account": "Kontoauszug",
            "Remove statement block?": "Anweisungsblock entfernen?",
        },

        "pt": {
            "Reminder": "Lembrete",
            "The password for the pdf is your document number registered in Phidias.": "A senha para o pdf é o seu número de documento registado no Phidias.",
            "The password for the pdf is your date of birth registered in Phidias in DDMMAA format (e.g. 020225).": "A senha para o pdf é a sua data de nascimento registada no Phidias no formato DDMMAA (por exemplo, 020225).",
            "The password for the pdf is your phone number registered in Phidias.": "A palavra-passe para o pdf é o seu número de telefone registado no Phidias.",
            "The password to open the PDF is your cell phone number registered in the system, including your country code. Be sure to include the international prefix with the plus sign (+).": "A palavra-passe para abrir o PDF é o seu número de telemóvel registado no sistema, incluindo o código do seu país. Não se esqueça de incluir o prefixo internacional com o sinal de mais (+). Exemplo: +57315332211.",
            "The password for the pdf is your id registered in Phidias.": "A palavra-passe para o pdf é a sua identificação registada no Phidias.",
            "Download statement of account": "Descarregar o extrato de conta",
            "Statement of Account": "Extrato de conta",
            "Remove statement block?": "Remover bloco de declaração?",
        }
    }
}
</script>

<style scoped lang="scss">
.content-file {
    color: #1c89b8 !important;
    background: rgba(0, 0, 0, 0.08);
    max-width: 130px;
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    .file {
        padding-left: 0px !important;
        i {
            color: #1c89b8 !important;
        }
    }
}
</style>